<template>
<sidebar-widget
    :start-expanded="true"
    :sections="sections"
    :headers="[{label: 'Name'},  {label: 'Amount', classes: 'cw-10'}, {label: 'Priority', classes: 'cw-6'}]"
>
    <template v-slot:title>Income Withholding Orders</template>

    <template v-slot:headerbutton v-if="$store.state.user.is_superuser">
        <button v-if="activeIWOs.length > 1" class="btn btn-outline-primary mr-1" @click.prevent.stop="reorderModalOpen = true"><i class="far fa-sort"></i> Reorder</button>
        <button class="btn btn-outline-primary" @click.prevent.stop="addModalOpen = true"><i class="far fa-plus"></i> Add</button>
    </template>

    <template v-slot:row-details="props">
        <div>
            <p>
                <span>Order date: </span>
                <span>{{ $filters.date(props.row.obj.order_date) }}</span>
            </p>
            <p>
                <strong>Monthly Amounts</strong>
            </p>
            <div>
                <div v-for="(label, key) in this.amountFields">
                    <div v-if="props.row.obj[key] != null && props.row.obj[key] != 0">
                        <span>{{ label }}: </span>
                        <span>{{ $filters.dollars(props.row.obj[key]) }}</span>
                        <span v-if="key == 'past_due_child_support_amount' && props.row.obj['arrears_gt_12_weeks']"> >12 weeks in arrears</span>
                        <br/>
                    </div>
                </div>
            </div>

            <button-row v-if="props.row.obj.is_active && $store.state.user.is_superuser">
                <button class="btn btn-outline-primary" @click.prevent="removeIWO(props.row.obj.id)"><i class="far fa-trash"></i> Delete</button>

                <button class="btn btn-outline-primary" @click.prevent="currentIWOId = props.row.obj.id; editModalOpen = true"><i class="far fa-pen"></i> Edit</button>
            </button-row>
        </div>
    </template>

    <template v-slot:extra>
        <IWOModal
            v-if="addModalOpen || editModalOpen"
            :iwo="currentIWO"
            :client="client"
            :employee="employee"
            @close="currentIWOId = null; addModalOpen = editModalOpen = false"
            @updated="$emit('updated'); getData()"
        />
        <IWOReorderModal
            v-if="reorderModalOpen"
            :client="client"
            :employee="employee"
            :iwos="activeIWOs"
            @close="reorderModalOpen = false"
            @updated="$emit('updated'); getData()"
        />
    </template>
</sidebar-widget>

</template>

<script>
import SidebarWidget from '@/components/SidebarWidget'
import ButtonRow from '@/components/ButtonRow'
import IWOModal from './IWOModal'
import IWOReorderModal from './IWOReorderModal'

export default {
    props: ['employee', 'client',],
    components: {SidebarWidget, ButtonRow, IWOModal, IWOReorderModal},
    computed: {
        activeIWOs() {
            return this.employee.iwos.filter(iwo => iwo.is_active)
        },
        sections() {
            const activeRows = []
            const inactiveRows = []
            const sortedIWOs = [...this.employee.iwos].sort((a, b) => {
                if (a.priority == null) return 1
                if (b.priority == null) return -1
                return a.priority - b.priority
            })

            sortedIWOs.forEach(d => {
                const amountString = this.$filters.dollars(d.total_amount)  + '/month'
                let row = {
                    obj: d,
                    cells: [
                        d.iwo_type.name,
                        amountString,
                        d.priority,
                    ],
                    id: d.id,
                }
                if (d.is_active) {
                    activeRows.push(row)
                } else {
                    inactiveRows.push(row)
                }
            })
            return [
                {title: 'Active', rows: activeRows, startExpanded: true},
                {title: 'Inactive', rows: inactiveRows, startExpanded: false},
            ]
        },
        currentIWO() {
            if (this.currentIWOId) {
                return this.employee.iwos.find(j => j.id == this.currentIWOId)
            }
            return undefined
        },
        amountFields() {
            return {
                current_child_support_amount: 'Current Child Support',
                past_due_child_support_amount: 'Past-Due Child Support',
                current_cash_medical_amount: 'Current Cash Medical Support',
                past_due_cash_medical_amount: 'Past-Due Cash Medical Support',
                current_spousal_amount: 'Current Spousal Support',
                past_due_spousal_amount: 'Past-Due Spousal Support',
                other_amount: 'Other',
                total_amount: 'Total Amount to Withhold',
            }
        },
    },
    data() {
        return {
            addModalOpen: false,
            editModalOpen: false,
            reorderModalOpen: false,
            removeModalOpen: false,
            currentIWOId: null,
        }
    },
    mounted() {
        this.getData(true)
    },
    methods: {
        removeIWO(iwoId) {
            if (confirm('Are you sure?')) {
                this.$store.dispatch('START_LOADING')
                const data = {
                    active_status: 'inactive',
                }

                return this.$api.post(`/clients/${this.client.id}/employees/${this.employee.id}/iwos/${iwoId}`, data).then(resp => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$bus.showInfo('Successfully removed order.')
                    this.$emit('updated')
                    this.getData()
                }).catch(errors => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$bus.showError(errors.__all__)
                })
            }
        },
        getData(silent) {}
    },
}
</script>
